<template>
	<div class="chuzulv2">
		<div v-for="(item,index) in chuzuList" :key="index" class="for" @click="setupChartClick(item,'shuju')">
			<div class="card-model">
				<div class="card-icon">
					<i :class="item.icon"></i>
				</div>
				<div class="card-right">
					<div class="card-type">
						<div class="dian" :style="{ backgroundColor: item.color }"> </div>
						{{ item.title }}
					</div>
					<div class="card-nums-row">
						<div class="card-num">
							{{ item.num }}<span class="danwei">处资产</span>
						</div>
						<!-- <div class="card-location">
							{{ item.locationNum }}<span class="danwei" style="color:#07e1ff;">个位置</span>
						</div> -->
					</div>
				</div>
			</div>
			<div class="card-bottom">
			</div>
		</div>
	</div>
</template>

<script>
	import apis from '@/http/apis';
	import chartClickMixin from "@/views/index/components/handlemixin.js"; // 引入点击事件

	// 固定图标映射
	const ICON_MAP = {
		'待出租': 'el-icon-s-promotion',
		'部分出租': 'el-icon-office-building',
		'已出租': 'el-icon-menu',
	};
	const DEFAULT_ICONS = ['el-icon-s-promotion', 'el-icon-office-building', 'el-icon-menu'];

	// 与饼图保持一致的颜色映射
	const COLOR_MAP = {
		'待出租': '#d7d228',
		'部分出租': '#0fb36e',
		'已出租': '#0075ff',
	};
	const DEFAULT_COLORS = ['#d7d228', '#0fb36e', '#0075ff'];

	export default {
		mixins: [chartClickMixin],
		name: 'RingChart',
		data() {
			return {
				chart: null,
				chuzuList: [
					{ icon: 'el-icon-s-promotion', title: '待出租', num: '--', locationNum: '--', color: '#d7d228' },
					{ icon: 'el-icon-office-building', title: '部分出租', num: '--', locationNum: '--', color: '#0fb36e' },
					{ icon: 'el-icon-menu', title: '已出租', num: '--', locationNum: '--', color: '#0075ff' },
				]
			};
		},
		created() {
			this.loadData();
		},
		mounted() {
			this.initChart();
		},
		beforeDestroy() {
			if (this.chart) {
				this.chart.dispose();
			}
		},
		methods: {
			loadData() {
				apis.assetRentalRate().then((res) => {
					console.log('[资产出租率] 接口返回数据:', res);
					const list = res && res.data && res.data.list ? res.data.list : [];
					// 固定三个分类顺序：已出租 → 部分出租 → 待出租，即使数量为 0 也始终显示
					const ALL_TYPES = ['已出租', '部分出租', '待出租'];
					this.chuzuList = ALL_TYPES.map((type, index) => {
						const found = list.find(item => item.name === type);
						if (found) {
							return {
								icon: ICON_MAP[found.name] || DEFAULT_ICONS[index % DEFAULT_ICONS.length],
								title: found.name,
								num: found.value,
								locationNum: found.locationCount != null ? found.locationCount : '--',
								color: COLOR_MAP[found.name] || DEFAULT_COLORS[index % DEFAULT_COLORS.length],
							};
						}
						// 接口未返回该分类（通常为 0）时，补全条目
						return {
							icon: ICON_MAP[type] || DEFAULT_ICONS[index % DEFAULT_ICONS.length],
							title: type,
							num: 0,
							locationNum: '--',
							color: COLOR_MAP[type] || DEFAULT_COLORS[index % DEFAULT_COLORS.length],
						};
					});
				});
			},
			initChart() {
			},
		}
	};
</script>

<style scoped>
	.chuzulv2 {
		width: 100%;
		height: 90%;
		display: flex;
		flex-direction: column;
	}

	.for {
		flex: 1;
		/* 每个card-model平分父容器高度 */
		min-height: 0;
		/* 防止内容溢出 */
		padding: 10px;
	}

	.for :hover {
		cursor: pointer;
	}

	.card-model {
		display: flex;
		align-items: center;
		padding: 10px 0px;
		height: calc(100% - 20px);
		/* 可选：添加分隔线 */
	}

	.card-bottom {
		height: 20px;
		width: 100%;
		background-image: url("../../../assets/iconbottom.png");
		background-size: 100% 100%;
	}

	.card-icon {
		background-image: url("../../../assets/iconbg.png");
		background-size: 100% 100%;
		margin-right: 15px;
		font-size: 30px;
		color: #ffffff;
		/* width: 80px; */
		width: 3.0vw;
		height: 6vh;
		/* height: 80px; */
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.card-right {
		flex: 1;
	}

	.dian {
		width: 15px;
		height: 15px;
		margin-right: 5px;
		border-radius: 20px;
		background-color: #07e1ff;
	}

	.card-type {
		font-size: 1.5vh;
		font-weight: 600;
		color: #07e1ff;
		margin-bottom: 5px;
		display: flex;
		align-items: center;
	}

	.card-nums-row {
		display: flex;
		align-items: baseline;
		gap: 12px;
	}

	.card-num {
		font-size: 2.0vh;
		font-weight: 700;
		color: #fcf883;
	}

	.card-location {
		font-size: 1.6vh;
		font-weight: 600;
		color: #07e1ff;
	}

	.danwei {
		font-size: 1.4vh;
		color: #fcf883;
	}
</style>